module.exports = __webpack_public_path__ + "assets/img/taptap-3b77da13.png";